// AdminPage.js
// Admin panel for support debugging - load any family by familyId

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';
import BottomNav from '../components/BottomNav';

function AdminPage() {
  const navigate = useNavigate();
  const { isAdmin, loadFamily, loadingFamily, adminError, setAdminError } = useAdmin();

  const [familyIdInput, setFamilyIdInput] = useState('');

  // Redirect if not admin (safety check, route should also be protected)
  if (!isAdmin) {
    return (
      <div className="admin-page">
        <div className="admin-header">
          <h1>Admin Panel</h1>
        </div>
        <div className="admin-unauthorized">
          <p>You are not authorized to access this page.</p>
          <button
            className="button button-secondary"
            onClick={() => navigate('/settings')}
          >
            Back to Settings
          </button>
        </div>
        <BottomNav />
      </div>
    );
  }

  const handleLoadFamily = async (e) => {
    e.preventDefault();
    setAdminError(null);

    if (!familyIdInput.trim()) {
      setAdminError('Please enter a family ID');
      return;
    }

    const success = await loadFamily(familyIdInput.trim());
    if (success) {
      // Navigate to todos page to view the family's data
      navigate('/todos');
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Admin Panel</h1>
        <p>Support debugging and concierge mode</p>
      </div>

      <div className="admin-section">
        <h2>View as Family</h2>
        <p>Enter a family ID to view their tasks and data as they see it.</p>

        <form onSubmit={handleLoadFamily} className="admin-form">
          {adminError && <div className="form-error">{adminError}</div>}

          <div className="form-group">
            <label htmlFor="familyId">Family ID</label>
            <input
              type="text"
              id="familyId"
              value={familyIdInput}
              onChange={(e) => setFamilyIdInput(e.target.value)}
              placeholder="e.g., family_abc123_1234567890"
            />
          </div>

          <button
            type="submit"
            className="button button-primary"
            disabled={loadingFamily}
          >
            {loadingFamily ? 'Loading...' : 'Load Family'}
          </button>
        </form>
      </div>

      <div className="admin-section admin-info">
        <h2>How it works</h2>
        <ul>
          <li>Enter a familyId to load that family's view</li>
          <li>A banner will appear at the top showing you're in admin mode</li>
          <li>You can view their tasks, comments, and notifications</li>
          <li>In task details, you can post concierge comments as "Kana" or "David"</li>
          <li>Concierge comments trigger notifications for the family</li>
          <li>Click "Exit" in the banner to return to your normal view</li>
        </ul>
      </div>

      <div className="admin-section">
        <button
          className="button button-secondary"
          onClick={() => navigate('/settings')}
        >
          Back to Settings
        </button>
      </div>

      <BottomNav />
    </div>
  );
}

export default AdminPage;
